
import { Component, Vue } from 'vue-property-decorator';
import ListItemHover from '@/components/base/ListItemHover.vue';
import { NotificationInterface, ProfileRepositoryInterface } from '@/services/Users-profile/interfaces';

@Component({
  components: {
    ListItemHover,
  },
  inject: [
    'profileRepository',
  ],
})
export default class Notifications extends Vue {
  private noNotificationsText: string = 'No new notifications...';
  private profileRepository!: ProfileRepositoryInterface;


  private get notifications(): NotificationInterface[] {
    return this.$store.getters.notifications.unread;
  }

  private get readNotifications(): NotificationInterface[] {
    return this.$store.getters.notifications.read;
  }

  private async markAllAsRead(): Promise<void> {
    this.$store.commit('MARK_ALL_AS_READ');
    await this.profileRepository.markAllNotificationsAsRead();
  }

  private async markAsRead(notificationId: string): Promise<void> {
    if (!notificationId) {
      return;
    }

    this.$store.commit('MARK_AS_READ', notificationId);
    await this.profileRepository.markNotificationAsRead(notificationId);
  }
}
